<script setup>
import { computed, defineEmits } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps({
  data: {
    type: Number,
    default: 0
  },
  rowData: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['navigate'])

const hasData = computed(() => {
  return props.data && props.data > 0
})

function navigateToSubmissions() {
  const ip = props.rowData?.ip || props.rowData?.ips?.[0]?.ip || props.rowData?.ips?.[0]
  if (ip) {
    emit('navigate', ip)
  }
}
</script>

<template>
  <div v-if="hasData" class="d-flex vertically-centered">
    <font-awesome-icon style="font-size: 1rem; color: #4b5563; margin-right: 0.5rem;" :icon="['fas', 'comment-dots']" />
      <span>{{ props.data }}</span>
    <span class="submission-icon ms-auto" @click.stop="navigateToSubmissions">
      <font-awesome-icon style="font-size: 1rem;" :icon="['fas', 'square-up-right']" />
    </span>
  </div>
</template>

<style scoped>
.submission-icon {
  color: #4b5563;
  cursor: pointer;
}

.submission-icon:hover {
  color: white;
}
</style>
